import React from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import wrapStore from '@src/utils/wrap-store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import xauCss from '@src/components/xau-animation-css';
import SevenSectionStore from './store';
import { AIRMEN, PAGE_ENUM, MECHA_LEVEL } from './config';
import { getAirmenInfo } from './utils';
import locales from './locales';
import mergeCssModuleName from '@src/utils/merge-css-module-name';
const styles = mergeCssModuleName(require('./index.less'), require('./locales.less'), require('./media.less'));

const SevenSection = ({ store }) => {
  store.use();

  const mechaType = getAirmenInfo(store.level)?.mechaType || [];

  const renderLevelPage = () => {
    return (
      <div className={cx(styles.levelPage, store.page === PAGE_ENUM.LEVEL && [styles.isShowPage, xauCss.AOS_ROOT])}>
        <div className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}>
          <div className={styles.deco} data-text="机兵" />
          <div className={styles.text}>{locales.mechaIntro}</div>
        </div>
        <div className={styles.block}>
          {AIRMEN.map((item, idx) => (
            <Link
              key={item.id}
              className={cx(styles.blockItem, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(idx + 1) })}
              onClick={() => store.onTogglePage(PAGE_ENUM.MECHA_TYPE, item.id)}
            >
              <div className={styles.label}>{`[ ${String(idx + 1).padStart(2, '0')}.${item.name} ]`}</div>
              <img src={item.block} alt={item.name} />
            </Link>
          ))}
        </div>
        <Link className={cx(styles.btnViewPedigreeChart, { ...xauCss.AOS_FADE.IN_DOWN.FAST_DELAY(4) })} onClick={() => store.onViewPedigreeChart()}>
          {locales.viewAllPedigreeChart}
        </Link>
      </div>
    );
  };

  const renderMechaInfo = () => {
    return (
      <div className={cx(styles.mechaInfoSwiper)}>
        <BaseSwiper key={store.page + store.level} store={store.mechaInfoSwiper}>
          {mechaType.map(info => (
            <div className={cx(styles.mechaInfo)} key={info.id}>
              <div className={styles.mecha}>
                <img src={info.mecha} alt={info.name} />
              </div>
              <div className={styles.mechaText}>
                <div className={styles.threatLevel}>
                  {`[ ${info?.threatLevel} ]`}
                  <span className={styles.number}>{info?.number}</span>
                </div>
                <div className={styles.mechaName}>{info?.name}</div>
                {/* {store.level === MECHA_LEVEL.PAWN && <div className={styles.type}>{info?.type}</div>} */}
                <div className={styles.attribute}>
                  {info?.attributes.map((item, index) => {
                    return (
                      <div className={cx(styles.attributeItem)} key={index}>
                        <span className={styles.name}>{`[ ${item.name} ]`}</span>
                        <span className={styles.divider}>{'>'}</span>
                        <span className={styles.value}>{`${item.value}`}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </BaseSwiper>
      </div>
    );
  };

  const renderMechaTab = () => {
    return (
      <div className={cx(styles.mechaTab, { ...xauCss.AOS_FADE.IN_DOWN.FAST_DELAY(1) })}>
        <div className={cx(styles.mechaTabSwiper)}>
          <BaseSwiper key={store.level} store={store.mechaTabSwiper}>
            {mechaType.map((item, idx) => (
              <div className={styles.tabItem} data-index={idx} key={item.id}>
                <img className={styles.tabItemImg} src={item.block} alt="" />
                <img className={styles.tabItemImgActive} src={item.blockHover} alt="" />
              </div>
            ))}
          </BaseSwiper>
        </div>
        <Link className={cx(styles.prevBtn)} onClick={store.mechaTabSwiper.goPrev} />
        <Link className={cx(styles.nextBtn)} onClick={store.mechaTabSwiper.goNext} />
        <div className={cx(styles.pagination)}>
          {mechaType?.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => store.mechaTabSwiper?.onChange(index)}
                className={cx(styles.slick, store.currentIndex === index && styles.slick_active)}
              />
            );
          })}
          <div className={styles.count}>
            {store.currentIndex + 1}/{mechaType?.length}
          </div>
        </div>
      </div>
    );
  };

  const renderMechaTypePage = () => {
    return (
      <div className={cx(styles.mechaTypePage, store.page === PAGE_ENUM.MECHA_TYPE && [styles.isShowPage, xauCss.AOS_ROOT], styles[store.level])}>
        <div className={styles.header}>
          <Link className={cx(styles.btnBack, { ...xauCss.AOS_FADE.IN_RIGHT.FAST_DELAY(1) })} onClick={() => store.onTogglePage(PAGE_ENUM.LEVEL)} />
          <div className={cx(styles.tabMenu, { ...xauCss.AOS_FADE.IN_LEFT.FAST_DELAY(1) })}>
            {AIRMEN.map(item => (
              <Link key={item.id} className={cx(styles.tabItem, store.level === item.id && styles.isActive)} onClick={() => store.onToggleLevel(item.id)}>
                <span>{item.name}</span>
              </Link>
            ))}
          </div>
        </div>
        <Link className={cx(styles.btnViewMechaInfo, { ...xauCss.AOS_FADE.IN_RIGHT.FAST_DELAY(2) })} onClick={() => store.onViewMechaInfo()} />
        <Link className={cx(styles.btnViewPedigreeChart, { ...xauCss.AOS_FADE.IN_LEFT.FAST_DELAY(2) })} onClick={() => store.onViewPedigreeChart()} />
        {renderMechaInfo()}
        {renderMechaTab()}
      </div>
    );
  };

  return (
    <div className={cx(styles.sevenSectionRoot)}>
      {renderLevelPage()}
      {renderMechaTypePage()}
    </div>
  );
};

export default wrapStore(SevenSection, SevenSectionStore);
